import { OepaUserAccount } from "@ohioepa/oepa-common-lib";

export const intLiveReloadAccount: OepaUserAccount = {
   loginName: '10211012', //'10211012',  '10143719', '10205647', 
    accountID: '10211012', //' '10211012',  '10143719', '10205647'
    firstName: 'Catherine', // 'Catherine',  'Jacquelin', 'Whitney'
    lastName: 'Robertson',  // 'Robertson', 'Jones', 'Whitney',
    primaryEMailAddress: 'catherine.robertson@epa.ohio.gov', // 'catherine.robertson@epa.ohio.gov', 'jacquelin.jones@epa.ohio.gov', 'whitney.white@epa.ohio.gov'
    type: 'E_BUSINESS_CENTER',
    roleList: [
      {
        name: 'DSWSWIMSSystemAdmin',
        description: 'SWIMS Admin',
        privilegeList: [
          { type: 'NO_TYPE', name: 'create' },
          { type: 'NO_TYPE', name: 'update' },
        ]
      },
      {
        name: 'DSWSWIMSAppAdmin',
        description: 'SWIMS Application Admin',
        privilegeList: [
          { type: 'NO_TYPE', name: 'create' },
          { type: 'NO_TYPE', name: 'update' },
        ]
      },
      {
        name: 'DSWSWIMSDistComplianceLead',
        description: 'SWIMS District Compliance Lead',
        privilegeList: [
          { type: 'NO_TYPE', name: 'create' },
          { type: 'NO_TYPE', name: 'update' },
        ]
      }
    ]
  }